export default function ErrorBoundary() {
  console.error("🚨 ROUTER ERROR BOUNDARY HIT!");
  return (
    <div style={{ padding: '20px', background: 'red', color: 'white' }}>
      <h1>ROUTER ERROR!</h1>
      <p>Check console for details</p>
    </div>
  );
}
